import * as React from 'react'
import { Form, Formik } from 'formik'
import { ActivityFormActions } from './ActivityFormActions'
import { ActivityFormHeader } from './ActivityFormHeader'
import { useData, useHandlers, useInitValues, useValidations } from './hooks'
import { EditActivityFormFields } from './EditActivityFormFields'
import { Activity } from '@user/features/Activity'
import Stack from '@mui/material/Stack'

export type Props = {
  activity: Activity
  onClose: () => void
  onSave?: (activity: Activity) => void
}

export function EditActivityForm(props: Props) {
  const { activity, onClose } = props
  const { activityTypes, owners } = useData(activity.salesTeamId)
  const { onSubmit } = useHandlers(props, activityTypes, owners)
  const initValues = useInitValues(activity)
  const { validate } = useValidations()

  return (
    <Formik initialValues={initValues} onSubmit={onSubmit} validate={validate}>
      <Form>
        <Stack width={355} padding={2}>
          <ActivityFormHeader />
          <EditActivityFormFields
            activityTypes={activityTypes}
            owners={owners}
            salesTeamId={activity.salesTeamId}
            {...props}
          />
          <ActivityFormActions onCancelClick={onClose} />
        </Stack>
      </Form>
    </Formik>
  )
}
